import { photoSrc, triwulanLabel } from "./constants";

const esc = (s) =>
  String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const flattenRows = (jobs) =>
  jobs.flatMap((j) => j.items.map((item) => ({ job: j, item })));

const download = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};

const todayLabel = () =>
  new Date().toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" });

const rowsHtml = (jobs) =>
  flattenRows(jobs)
    .map(
      ({ job, item }) => `
      <tr>
        <td style="border:1px solid #888;padding:6px;font-weight:bold">${esc(item.gedung || job.title)}</td>
        <td style="border:1px solid #888;padding:6px">${esc(item.lantai)}</td>
        <td style="border:1px solid #888;padding:6px">${esc(item.ruang)}</td>
        <td style="border:1px solid #888;padding:6px">${esc(item.kategori)}</td>
        <td style="border:1px solid #888;padding:6px">${esc(item.kondisi)}</td>
        <td style="border:1px solid #888;padding:6px">${esc(item.spesifikasi)}</td>
        <td style="border:1px solid #888;padding:6px">${esc(item.detail)}</td>
        <td style="border:1px solid #888;padding:6px">${esc(item.bahan)}</td>
        <td style="border:1px solid #888;padding:6px;font-weight:bold">${esc(item.status)}</td>
      </tr>`
    )
    .join("");

const tableHtml = (jobs) => `
  <table style="width:100%;border-collapse:collapse;font-size:11px">
    <thead><tr style="background:#e2e8f0">
      <th style="border:1px solid #888;padding:6px">Gedung</th>
      <th style="border:1px solid #888;padding:6px">Lantai</th>
      <th style="border:1px solid #888;padding:6px">Ruang</th>
      <th style="border:1px solid #888;padding:6px">Kategori</th>
      <th style="border:1px solid #888;padding:6px">Kondisi</th>
      <th style="border:1px solid #888;padding:6px">Spesifikasi</th>
      <th style="border:1px solid #888;padding:6px">Detail Pengerjaan</th>
      <th style="border:1px solid #888;padding:6px">Bahan / Material</th>
      <th style="border:1px solid #888;padding:6px">Status</th>
    </tr></thead>
    <tbody>${rowsHtml(jobs)}</tbody>
  </table>`;

const photosHtml = (jobs) => {
  const all = flattenRows(jobs).flatMap(({ job, item }) =>
    (item.photos || []).map((url) => ({ job, url }))
  );
  if (!all.length) return "";
  const cells = all.map(
    ({ job, url }, i) => `
      <td style="width:33%;vertical-align:top;border:1px solid #cbd5e1;padding:6px;text-align:center">
        <img src="${photoSrc(url)}" style="width:200px;height:150px;object-fit:cover" /><br/>
        <b>Foto #${i + 1}</b><br/><span style="font-size:10px;color:#555">${esc(job.title)} - ${esc(job.location_name)}</span>
      </td>`
  );
  const rows = [];
  for (let i = 0; i < cells.length; i += 3) rows.push(`<tr>${cells.slice(i, i + 3).join("")}</tr>`);
  return `<h3 style="margin-top:24px;border-bottom:1px solid #000;padding-bottom:4px">LAMPIRAN FOTO BUKTI</h3>
    <table style="width:100%;border-collapse:collapse">${rows.join("")}</table>`;
};

const header = (company, logoUrl) => `
  <div style="text-align:center;border-bottom:2px solid #000;padding-bottom:10px;margin-bottom:16px">
    ${logoUrl ? `<img src="${photoSrc(logoUrl)}" style="height:60px;margin-bottom:6px" /><br/>` : ""}
    <h1 style="font-size:18px;margin:0;text-transform:uppercase;letter-spacing:1px">Laporan Pekerjaan Service</h1>
    <p style="font-size:11px;color:#444;margin:4px 0 0">${esc(company)} &bull; Tanggal Cetak: ${todayLabel()}</p>
  </div>`;

export const exportWord = (jobs, company = "", logoUrl = "") => {
  const html = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
    <head><meta charset='utf-8'></head><body style="font-family:'Segoe UI',Arial,sans-serif">
    ${header(company, logoUrl)}${tableHtml(jobs)}${photosHtml(jobs)}</body></html>`;
  download(new Blob(["\ufeff", html], { type: "application/msword" }), `Laporan_Service_${Date.now()}.doc`);
};

export const exportExcel = (jobs) => {
  const html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body>
    <table border="1"><tr><th>Gedung</th><th>Lantai</th><th>Ruang</th><th>Kategori</th><th>Kondisi</th><th>Spesifikasi</th><th>Detail</th><th>Bahan</th><th>Status</th><th>Triwulan</th></tr>
    ${flattenRows(jobs).map(({ job, item }) => `<tr><td>${esc(item.gedung || job.title)}</td><td>${esc(item.lantai)}</td><td>${esc(item.ruang)}</td><td>${esc(item.kategori)}</td><td>${esc(item.kondisi)}</td><td>${esc(item.spesifikasi)}</td><td>${esc(item.detail)}</td><td>${esc(item.bahan)}</td><td>${esc(item.status)}</td><td>${esc(triwulanLabel(job))}</td></tr>`).join("")}
    </table></body></html>`;
  download(new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" }), `Data_Service_${Date.now()}.xls`);
};

export const printReport = () => window.print();

export const copyTable = async (jobs) => {
  const html = tableHtml(jobs);
  const text = flattenRows(jobs)
    .map(({ job, item }) => [item.gedung || job.title, item.lantai, item.ruang, item.kategori, item.kondisi, item.spesifikasi, item.detail, item.bahan, item.status].join("\t"))
    .join("\n");
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([text], { type: "text/plain" }),
      }),
    ]);
  } catch {
    await navigator.clipboard.writeText(text);
  }
};
